import { 
  IApiResponse, 
  ICheckEmailResult, 
  ICountry, 
  IExistingSiteUser, 
  ILanguage, 
  ISiteAccountStatus, 
  ISiteAccountType, 
  ISiteCheckResult, 
  ISystemUserType, 
  ITitlePrefix, 
  IUserStatusType } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class CommonService extends BaseService {
  
  public getTitlePrefixes = async (enabledonly: boolean) : Promise<Array<ITitlePrefix>> => {
    const url: string = `/Common/GetTitlePrefixes/${enabledonly}`;
    const res = await this._ajaxService.Get<IApiResponse>(url, true);

    if (res?.StatusCode === 200 && res.ReturnData) {
      return res.ReturnData;
    } else {
      if (res?.StatusCode !== 404) {
        this.EmitDataError(res, "Failed to retrieve title prefixes");
      }
    }
    return [];
  }

  public getCountries = async (enabledonly: boolean) : Promise<Array<ICountry>> => {
    const url: string = `/Common/Getcountries/${enabledonly}`;
    const res = await this._ajaxService.Get<IApiResponse>(url, true);

    if (res?.StatusCode === 200 && res.ReturnData) {
      return res.ReturnData;
    } else {
      if (res?.StatusCode !== 404) {
        this.EmitDataError(res, "Failed to retrieve country list");
      }
    }
    return [];
  }

  public getUserAccountTypes = async (includeSystem: boolean) : Promise<Array<any>> => {
    if (this.siteKey) {
      const url: string = `/Common/GetUserAccountTypes/${includeSystem}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve user account types");
        }
      }
    }
    return [];
  }

  public getUserStatusTypes = async () : Promise<Array<IUserStatusType>> => {
    if (this.siteKey) {
      const url: string = `/Common/GetUserStatusList`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve user status types");
        }
      }
    }
    return [];
  }

  public getAccountStatusTypes = async () : Promise<Array<ISiteAccountStatus>> => {
    if (this.siteKey) {
      const url: string = "/SystemAccounts/GetAccountStatusList";
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve account status types");
        }
      }
    }
    return [];
  }

  public getSystemUserTypes = async () : Promise<Array<ISystemUserType>> => {
    if (this.siteKey) {
      const url: string = "/Common/GetSystemUserTypes";
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve system user types");
        }
      }
    }
    return [];
  }

  public getSiteAccountTypes = async () : Promise<Array<ISiteAccountType>> => {
    if (this.siteKey) {
      const url: string = "/SystemAccounts/GetAccountTypes";
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve site account types");
        }
      }
    }      
    return [];
  }

  public userExists = async (emailaddress: string) : Promise<IExistingSiteUser | null> => {
    if (emailaddress) {
      const url: string = `/Common/CheckEmailExists`;
      const model = {
        EmailAddress: emailaddress
      };
      const res = await this._ajaxService.Post<IApiResponse>(url, model, false);
      if ((res?.StatusCode === 200 || res?.StatusCode === 409) && res.ReturnData) {
        return res.ReturnData;
      }
    }
    return null;
  }

  public checkSiteName = async (sitename: string) : Promise<ISiteCheckResult | null> => {
    const checkmodel = {
      SiteName: sitename,
      SubDomain: "",
      Domain: ""
    };
    const url: string = `/Common/CheckSiteName`;
    const res = await this._ajaxService.Post<IApiResponse>(url, checkmodel, false);

    if ((res?.StatusCode === 200 || res?.StatusCode === 409) && res.ReturnData) {
      return res.ReturnData;
    } 
    return null;
  }

  public checkSiteDomain = async (domain: string) : Promise<ISiteCheckResult | null> => {
    const checkmodel = {
      SiteName: "",
      SubDomain: "",
      Domain: domain
    };
    const url: string = `/Common/CheckDomain`;
    const res = await this._ajaxService.Post<IApiResponse>(url, checkmodel, false);

    if ((res?.StatusCode === 200 || res?.StatusCode === 409) && res.ReturnData) {
      return res.ReturnData;
    } 
    return null;
  }

  public checkSiteSubDomain = async (subdomain: string) : Promise<ISiteCheckResult | null> => {
    const checkmodel = {
      SiteName: "",
      SubDomain: subdomain,
      Domain: ""
    };
    const url: string = `/Common/CheckSubDomain`;
    const res = await this._ajaxService.Post<IApiResponse>(url, checkmodel, false);

    if ((res?.StatusCode === 200 || res?.StatusCode === 409) && res.ReturnData) {
      return res.ReturnData;
    } 
    return null;  
  }

  public getAllLanguages = async (): Promise<ILanguage[]> => {
    let langs = [];

    try {
      const url = `/Common/GetDefaultLanguages`;
      const res = await this._ajaxService.Get<IApiResponse>(url, false);
      if (res?.Success && res?.ReturnData) {
        langs = res.ReturnData;
      }
    } catch(error) {
      console.error(error);
      debugger;
    }
    return langs;
  }
  
  public checkEmailAddress = async (email: string) : Promise<ICheckEmailResult | null> => {
    if (email) {
      const url: string = "/Common/CheckEmailExists";
      const model = {
        EmailAddress: email
      };
      const res = await this._ajaxService.Post<IApiResponse>(url, model, false);
      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } 
    }
    return null;
  }
}